/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React from 'react'
// eslint-disable-next-line
import { useMapsLibrary } from '@vis.gl/react-google-maps/dist/index.umd.js'
import { useSelector } from 'react-redux'
import { Paper, Button, TextField } from '@material-ui/core'
import { GpsFixedOutlined } from '@material-ui/icons'
import mapInfoWindowStyles from './mapInfoWindowStyles'

const AutoCompleteSearchbar = ({
  label,
  placeholder,
  dispatch,
  dispatchAction,
  destination,
  enableGeolocationButton = false,
  darkMode,
}) => {
  const { lat, lng } = useSelector((s) => s.maps)
  const places = useMapsLibrary('places')
  const [placesService, setPlacesService] = React.useState(null)
  const [value, setValue] = React.useState('')
  const [predictions, setPredictions] = React.useState([])
  const [selectedIndex, setSelectedIndex] = React.useState(-1)
  const classes = mapInfoWindowStyles()

  const fetchPlacesPredictions = (valueInput) => {
    if (placesService && valueInput) {
      placesService.getPlacePredictions(
        {
          input: valueInput,
          locationBias: {
            center: new window.google.maps.LatLng(lat, lng),
            radius: 100,
          },
        },
        (preds) => {
          setPredictions(preds || [])
        },
      )
    } else {
      setPredictions([])
    }
  }

  const handleSelect = (prediction) => {
    dispatch(dispatchAction(prediction.description))
    setValue(prediction.description)
    setPredictions([])
  }

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setSelectedIndex((i) => Math.min(i + 1, predictions?.length - 1))
    } else if (e.key === 'ArrowUp') {
      setSelectedIndex((i) => Math.max(i - 1, 0))
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      const selected = predictions[selectedIndex]
      if (selected) {
        setValue(selected.description)
        dispatch(dispatchAction(selected.description))
        setPredictions([])
      }
    }
  }

  const handleInput = (e) => {
    const inputValue = e.target.value
    setValue(inputValue)
    fetchPlacesPredictions(inputValue)
  }

  // Set initial destination
  React.useEffect(() => {
    if (destination) {
      setValue(destination)
    }
  }, [destination])

  // Set up the places autocomplete service
  React.useEffect(() => {
    if (places && !placesService) {
      setPlacesService(new places.AutocompleteService())
    }
  }, [places])

  const getUserLocation = () => {
    if (!navigator.geolocation) {
      //   alert('Geolocation is not supported by your browser.')
      return
    }

    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords
      const geocoder = new window.google.maps.Geocoder()
      const latlng = { lat: latitude, lng: longitude }

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const address = results[0].formatted_address
          setValue(address)
          dispatch(dispatchAction(address))
          setPredictions([])
        } else {
          // alert('Unable to determine address from location.')
        }
      })
    })
  }

  // Handle geolocation button click
  const handleUseMyLocation = () => {
    getUserLocation()
  }

  React.useEffect(() => {
    if (enableGeolocationButton) {
      getUserLocation()
    }
  }, [])

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', position: 'relative' }}
    >
      <TextField
        variant="outlined"
        value={value}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        label={label}
        style={{ width: enableGeolocationButton ? 188 : 230 }}
        size="small"
      />
      {enableGeolocationButton && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleUseMyLocation}
          className={classes.navigateButton}
          style={{
            marginLeft: 2,
            height: '100%',
            minWidth: 40,
            cursor: 'pointer',
          }}
        >
          <GpsFixedOutlined fontSize="20px" />
        </Button>
      )}
      {predictions?.length > 0 && (
        <Paper
          component="ul"
          style={{
            listStyle: 'none',
            margin: 0,
            padding: '4px 0',
            position: 'absolute',
            top: '100%',
            left: 0,
            border: '1px solid #ccc',
            zIndex: 999,
            width: 230,
          }}
        >
          {predictions.map((prediction, index) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <li
              key={prediction.place_id}
              onClick={() => handleSelect(prediction)}
              style={{
                padding: '8px',
                backgroundColor:
                  // eslint-disable-next-line
                  index === selectedIndex
                    ? darkMode
                      ? '#5a5252ff'
                      : '#eee'
                    : 'transparent',
                cursor: 'pointer',
              }}
            >
              {prediction.description}
            </li>
          ))}
        </Paper>
      )}
    </div>
  )
}

export default AutoCompleteSearchbar
